module.exports = __webpack_public_path__ + "static/img/1-3.b2b62d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-3.jpg
// module id = N2z4
// module chunks = 1